import { AxiosInstance } from 'axios';
import http from '@student/http';

function downloadLoanAgreementCtor(http: AxiosInstance) {
  return async function downloadLoanAgreement(sessionId: string): Promise<Blob> {
    const { data } = await http.get(`/loan-agreement/pre/${sessionId}`);
    const bytes = new Uint8Array(data.pdf.data);
    return new Blob([bytes], { type: 'application/pdf' });
  };
}

export default downloadLoanAgreementCtor(http);
